import BaseRequest from '@common/services/_baseRequest';

export default {

	list: (params, cb, ecb = null) => {
		//console.warn("TP.1", params)
		var req = new BaseRequest();
		return req.makeRequest(
			params,
			{},
			null,
			'get',
			'gestionelr/gestore-lr/list',
			cb,
			ecb || null,
			null
		);
	},

	save: ( data, cb, ecb = null) => {
		var req = new BaseRequest();
		req.makeRequest(
			{},
			data,
			null,
			"post",
			'gestionelr/gestore-lr/save',
			cb,
			ecb || null,
			null,
			true,
			false
		);
	},

	accetta: ( params, cb, ecb = null) => {
		var req = new BaseRequest();
		req.makeRequest(
			params,
			{},
			null,
			'get',
			'gestionelr/gestore-lr/accetta',
			cb,
			ecb || null,
			null
		);
	},

}   
